import { httpClient, apiLinks } from '@app/utils';

import { Token } from '@app/models/token';
import { ChangePasswordArgs } from '@app/pages/forgot-password';

const login = async (username: string, password: string): Promise<Token> => {
  const response = await httpClient.post<Token>({
    url: apiLinks.auth.token,
    // data: `grant_type=password&username=${username}&password=${password}`,
    data: {
      username,
      password,
    },
  });
  return response.data;
};

const getUserInfo = async (): Promise<Token> => {
  const response = await httpClient.get<Token>({
    url: apiLinks.admin.userManagement.getUserProfile,
  });
  return response.data;
};

const changePassword = async (data: ChangePasswordArgs): Promise<unknown> => {
  const response = await httpClient.post({
    url: apiLinks.admin.userManagement.confirmChangePassword,
    data,
  });

  return response.data;
};

const forgetPassword = async (username: string): Promise<void> => {
  await httpClient.post({
    url: `${apiLinks.admin.userManagement.forgetPassword}/${username}`,
  });
};

const authService = {
  login,
  getUserInfo,
  changePassword,
  forgetPassword,
};

export default authService;
